import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateEventReviewStatus } from '../services/events';
import { eventReviewsQueryKeys } from './query-keys';

export const useUpdateEventReviewStatusMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ eventId, reviewId, status }) => {
      const result = await updateEventReviewStatus(eventId, reviewId, status);
      if (!result.success) {
        throw new Error(result.message || 'Failed to update review status');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      const { eventId } = variables ?? {};
      await queryClient.invalidateQueries({ queryKey: eventReviewsQueryKeys.all });
      if (eventId) {
        await queryClient.refetchQueries({
          queryKey: eventReviewsQueryKeys.list(eventId),
          type: 'active',
        });
      } else {
        await queryClient.refetchQueries({
          queryKey: eventReviewsQueryKeys.all,
          type: 'active',
        });
      }
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
